import localStorageFunc from "../../helpers/localStorageFunc";
export default {
  namespaced: true,
  state: {
    toastMessage: "",
    showToastMsg: false,
  },
  mutations: {
    updateToastMessage(state, payload) {
      state.toastMessage = payload;
    },
    updateShowToastMsg(state, payload) {
      state.showToastMsg = payload;
    },
    clearToastMsgState(state) {
      state.showToastMsg = false;
      state.toastMessage = "";
    },
  },
  actions: {
    getToastMessagesFromLocalStorage({ commit, state }) {
      let toastMsgs = localStorageFunc.getToastNotifications();
      toastMsgs.map((toast, index) => {
        setTimeout(() => {
          commit("updateToastMessage", toast?.msg);
          commit("updateShowToastMsg", true);
          setTimeout(() => {
            if (state.toastMessage == toast?.msg) {
              commit("clearToastMsgState");
            }
          }, toast?.duration || 9000);
        }, index * 1000);
      });
      localStorageFunc.clearToastNotifications();
    },
  },
};
